import styled from "styled-components"

import { DropdownBase } from "../../components/internal"

export const Container = styled.div`
  display: inline-block;
  max-width: 310px;
  position: relative;
  width: 100%;
`

export const FullContainer = styled.div`
  position: relative;
`

export const List = styled(DropdownBase)`
  width: 100%;
`
